import DragDropMouse from './dragdrop-mouse';
import DragDropKeyboard from './dragdrop-keyboard';

export default class DragDropView {
  constructor() {
    const container = document.querySelector('#skill-list');
    const region = document.querySelector('#live');

    this.dragDropMouse = new DragDropMouse({ container });
    this.dragDropKeyboard = new DragDropKeyboard({ container, region });
  }
};



// WEBPACK FOOTER //
// in/scripts/dragdrop-view.js